/**
 * The typographic vocabularies a theme persists.
 *
 * These were untyped until now: every font property went through one permissive
 * `string | number | null | boolean | unknown[]` union, so `'uppercase'`, `'140%'` and `false` were
 * all equally valid values for `textTransform`. Naming the three closed sets here is what lets the
 * font schema say what it actually holds.
 */

/**
 * Length unit for a size the theme stores.
 *
 * The two `@sites/entity-core`'s `numberWithUnitSchema` allows, and the two anything has ever
 * written: sizes, letter-spacing and borders in `px`, line-height in `%`. It carried `rem` and `em`
 * for a while on the argument that a panel might start offering them — nothing did, and a
 * vocabulary wider than the schema it feeds is a vocabulary that lets a value through which the
 * schema then rejects.
 *
 * A named alias over the schema's own literals, so `ThemeCssUnit.px` reads better than `'px'` at
 * the sixty-odd places that write one.
 */
export enum ThemeCssUnit {
    px = 'px',
    percent = '%',
}

/** `font-style`, as the italic toggle writes it. */
export enum ThemeFontStyle {
    normal = 'normal',
    italic = 'italic',
}

/** `text-transform`, as the uppercase toggle writes it. */
export enum ThemeTextTransform {
    none = 'none',
    uppercase = 'uppercase',
    lowercase = 'lowercase',
    capitalize = 'capitalize',
}
